import { ComponentMultiStyleConfig } from "@chakra-ui/react";

import responsiveStyle from "@lib/theme/responsiveStyle";

const Login: ComponentMultiStyleConfig = {
  parts: ["title", "linkContainer"],
  baseStyle: {
    title: {
      alignSelf: "center",
      textAlign: "center",
      px: "1rem",
      mt: "1.2rem",
      mb: "0.4rem",
    },
    linkContainer: {
      fontSize: responsiveStyle({ mobile: "0.875rem", desktop: "1rem" }),
    },
    socialWrapper: {
      alignItems: "center",
      justifyContent: "center",
      width: "376px",
      display: "flex",
      margin: "0 auto",
      "@media (max-width: 390px)": {
        width: "250px",
      }
    },
    facebookLogin: {
      background: "#1877f2",
      padding: "12px 24px",
      borderRadius: "8px",
      display: "flex",
      justifyContent: "center",
      height: "48px",
      width: "100%",
    },
    facebookLoginShorter: {
      background: "#1877f2",
      padding: "12px 24px",
      borderRadius: "8px",
      display: "flex",
      justifyContent: "center",
      height: "48px",
      width: "180px",
    },
    googleLogin: {
      marginLeft: "16px",
      background: "white",
      border: "1px solid #dadce0",
      borderRadius: "8px",
      padding: "12px 24px",
      display: "flex",
      justifyContent: "center",
      cursor: "pointer",
      _hover: {
        textDecoration: "none",
      },
      height: "48px",
      width: "100%",
    },
  },
};

export default Login;